import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Building: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 31 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.427 20.0003H13.7346V18.3389H5.427V20.0003Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.427 26.6458H13.7346V24.9844H5.427V26.6458Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.427 13.3548H13.7346V11.6934H5.427V13.3548Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0422 0.894531V6.7094H23.7038V0.894531H22.0422Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0588 2.55762V6.7111H18.7204V2.55762H17.0588Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.59595 6.71253C4.59595 6.25376 4.9679 5.88184 5.42671 5.88184H25.3651C25.8238 5.88184 26.1958 6.25376 26.1958 6.71253V34.1255C26.1958 34.5842 25.8238 34.9562 25.3651 34.9562H5.42671C4.9679 34.9562 4.59595 34.5842 4.59595 34.1255V6.71253ZM6.25748 7.54323V33.2948H24.5343V7.54323H6.25748Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8887 20.0003H22.0425V18.3389H17.8887V20.0003Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8887 26.6458H22.0425V24.9844H17.8887V26.6458Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8887 13.3548H22.0425V11.6934H17.8887V13.3548Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.442627 33.293H30.3502V34.9544H0.442627V33.293Z"
        fill="currentColor"
      />
    </svg>
  )
})

Building.displayName = 'Building'
